module.exports = __webpack_public_path__ + "static/media/5.0a234da8.jpg";